<template>
	<div>
		<BookmarksButton @click="toggleDrawer" />

		<SuiNavDrawer v-model="showDrawer">
			<BookmarksDrawerSkeleton v-if="loading" />

			<template v-else>
				<SuiListGroup
					v-if="haveBookmarks"
					class="bookmarks-shortcut__list"
					:list-data="bookmarksListGroup"
				/>
				<SuiStaticMessage
					v-else
					class="bookmarks-shortcut__empty-message"
					size="compact"
				>
					{{ $t('spa__bookmarks.favoriteBookmarks.info') }}
				</SuiStaticMessage>
			</template>
		</SuiNavDrawer>
	</div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import {
	SuiListGroup,
	SuiNavDrawer,
	SuiStaticMessage,
	type GroupedList,
} from '@developers/scoro-ui';
import BookmarksDrawerSkeleton from './BookmarksDrawerSkeleton.vue';
import { useBookmarksShortcutLazyQuery } from '@/generated/graphql';
import BookmarksButton from '../BookmarksButton.vue';

export default defineComponent({
	components: {
		BookmarksDrawerSkeleton,
		BookmarksButton,
		SuiNavDrawer,
		SuiListGroup,
		SuiStaticMessage,
	},

	setup() {
		const { result, load, loading } = useBookmarksShortcutLazyQuery();
		const showDrawer = ref(false);

		const toggleDrawer = () => {
			showDrawer.value = true;
			load();
		};

		const bookmarksListGroup = computed<GroupedList[]>(() => [
			{
				id: 'group-1',
				items:
					result.value?.FavoriteBookmarks.map((bookmark) => ({
						id: bookmark.id,
						title: bookmark.name,
						icon: { name: 'icon-bookmark-16', classes: [] },
						href: `/${bookmark.moduleUrl}?bookmark_id=${bookmark.id}`,
						target: '',
					})) ?? [],
			},
		]);

		return {
			toggleDrawer,
			showDrawer,
			bookmarksListGroup,
			loading,
			haveBookmarks: computed(
				() => !!result.value?.FavoriteBookmarks.length
			),
		};
	},
});
</script>

<style lang="scss">
.bookmarks-shortcut {
	&__empty-message {
		margin: 3rem;
	}

	&__list {
		.list-item__left-content .sui-icon {
			fill: $neutral-60;
		}
	}
}
</style>
